import script from "./MyTicketHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MyTicketHeader.vue?vue&type=script&setup=true&lang=js"

import "./MyTicketHeader.vue?vue&type=style&index=0&id=4773a324&lang=css"

const __exports__ = script;

export default __exports__